

export class Item_Size {
    // 1,125,899,906,842,624
    //     1,099,511,627,776
    // 9,007,199,254,740,991
    // P,  T,  G,  M,  K,
    // 9,123,456,789,123,456
    // 15
    protected static levels = [
        [15, 'PB', 1125899906842624],
        [12, 'TB', 1099511627776],
        [9,  'GB', 1073741824],
        [6,  'MB', 1048576],
        [3,  'KB', 1024],
        [0,  'B',  1]
    ];

    public constructor() {
    }

    public static intWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    public static intToHuman(intSize) {

        let str     = intSize + '';
        intSize     = parseInt(str);

        let ret     = {
            human: '0B',                               // 24 TB
            num: 0,                                     // 24
            int: intSize,                               // 24123456789
            str: Item_Size.intWithCommas(intSize),      // 24,123,456,789,123
            unit: 'B'                                   // TB
        };

        let base = 1;

        for (let idx = 0; idx < Item_Size.levels.length; idx++) {
            // 找到最大的单位
            if (intSize >= Item_Size.levels[idx][2]) {
                base        = parseInt(String(Item_Size.levels[idx][2]));
                ret.num     = Math.floor(intSize / base);
                ret.unit    = String(Item_Size.levels[idx][1]);
                ret.human   = ret.num + '' + ret.unit;
                break;
            }
        }

        return  ret;

    }

}
